export default __webpack_public_path__ + "static/media/down_arrow.dc487bbe.svg";